import { render, staticRenderFns } from "./VDependencyInput.vue?vue&type=template&id=192a32e2&"
import script from "./VDependencyInput.vue?vue&type=script&lang=js&"
export * from "./VDependencyInput.vue?vue&type=script&lang=js&"
import style0 from "./VDependencyInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports